import '@hotwired/turbo-rails'

// Turbo.session.drive = false

import Rails from '@rails/ujs'
Rails.start()

import jquery from 'jquery'
window.jQuery = jquery
window.$ = jquery

import * as bootstrap from 'sard_core/vendor/assets/bootstrap/javascripts/bootstrap.js'
window.bootstrap = bootstrap

// chartkick & highcharts
import 'chartkick'
window.Chartkick = Chartkick

import 'highcharts'
import Highcharts from 'highcharts'
window.Highcharts = Highcharts
// END chartkick & highcharts

// TODO: used ?
// import HighchartsMore from 'highcharts/highcharts-more'

// // Initialize the module
// HighchartsMore(Highcharts)

import { application } from './controllers/application'

// Sard Core
import 'sard_core/app/javascript/shared/core'

import FlashController from 'sard_core/app/javascript/controllers/flash_controller'
application.register('flash', FlashController)

import OtpDigitFieldController from 'sard_core/app/javascript/controllers/otp_digit_field_controller'
application.register('otp-digit-field', OtpDigitFieldController)

import TomSelectController from 'sard_core/app/javascript/controllers/tomselect_controller'
application.register('tomselect', TomSelectController)

import ScrollSlideoutMenuController from 'sard_core/app/javascript/controllers/scroll_slideout_menu_controller'
application.register('scroll-slideout-menu', ScrollSlideoutMenuController)
// END Sard Core

import Sortable from '@stimulus-components/sortable'
application.register('sortable', Sortable)

import './controllers'
import './custom'

// // Turbo Stream Actions
// import { StreamActions } from "@hotwired/turbo"

// StreamActions.redirect = function () {
//   Turbo.visit(this.getAttribute('target'))
// }
// // END Turbo Stream Actions
